import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-ui-filters',
  templateUrl: './ui-filters.component.html',
  styleUrls: ['./ui-filters.component.css'],
  standalone: false,
})
export class UiFiltersComponent {
  @Input() formGroup!: FormGroup;
  @Input() open = false;
  @Input() alwaysOpen = false;
  @Input() asDropdown = false;
  @Input() dropdownLabel = 'Filtros';
  @Input() clearLabel = 'Limpiar filtros';
  @Input() moreFiltersLabel = 'Más filtros';
  @Input() hideDesktopActions = false;

  @Output() openChange = new EventEmitter<boolean>();
  @Output() clear = new EventEmitter<void>();
  @Output() apply = new EventEmitter<void>();

  toggleFilters(): void {
    this.open = !this.open;
    this.openChange.emit(this.open);
  }

  closeFilters(): void {
    this.open = false;
    this.openChange.emit(false);
  }
}
